import React, { useEffect, useState } from 'react';
import AddIcon from '@material-ui/icons/Add';
import { Grid, Button } from '@material-ui/core';

import { useStyles } from './styles';
import { IFilters } from './interfaces';
import { useGroupsGql } from '../../graphql/groups';
import { Can } from '../../../../../components/util/Can';
import { useSuppliersGql } from '../../graphql/suppliers';
import { SearchBar } from 'components/migrated/searchbar';
import { DatePicker } from 'components/migrated/datepicker';
import { InAcessMoveis } from '../../graphql/groups/interfaces';
import { useSnackbar, useEnvironment } from '../../../../../hooks';
import { IOption } from '../../../../../components/migrated/enhancedautocomplete/interfaces';
import { EnhancedAutocomplete as Autocomplete } from '../../../../../components/migrated/enhancedautocomplete';

const dataDivisions = [
  {
    productDivisionKey: 'A',
    productDivisionName: 'Acessórios'
  },
  {
    productDivisionKey: 'P',
    productDivisionName: 'Móveis'
  }
];

export const TokVisionFiltersBar = (props: IFilters) => {
  const { onClickAdd, filters, setFilters } = props;
  const { runGroupsGql, dataGroups, errorGroups, loadingGroups } = useGroupsGql();
  const { runSuppliersGql, dataSuppliers, errorSuppliers, loadingSuppliers } = useSuppliersGql();
  const { DEBUG } = useEnvironment();
  const { Snackbar, toggleSnackbar } = useSnackbar();
  const classes = useStyles();

  const [selectedSupplier, setSelectedSupplier] = useState<IOption | null>(null);
  const [selectedDivision, setSelectedDivision] = useState<IOption | null>(null);
  const [selectedGroup, setSelectedGroup] = useState<IOption | null>(null);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  const handleSupplierChange = (option: IOption | null) => {
    setSelectedSupplier(option);
  };

  const handleDivisionChange = (option: IOption | null) => {
    setSelectedDivision(option);
    if (!option) {
      setSelectedGroup(null);
    }
  };

  const handleGroupChange = (option: IOption | null) => {
    setSelectedGroup(option);
  };

  const handleSearch = (value: string) => {
    setSearchTerm(value);
  };

  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
  };

  const handleAddClick = () => {
    onClickAdd();
  };

  const handleClearFilters = () => {
    setSelectedDivision(null);
    setSelectedGroup(null);
    setSearchTerm('');
    setSelectedDate(null);
  };

  useEffect(() => {
    runSuppliersGql();
  }, []);

  useEffect(() => {
    if (filters.productDivisionIndicator) {
      runGroupsGql({
        variables: {
          inAcessMoveis: filters.productDivisionIndicator!
        }
      });
    }
  }, [filters.productDivisionIndicator]);

  useEffect(() => {
    if (filters.routerPersonId) {
      const defaultSupplier = dataSuppliers.find((item) => String(item.personId) === String(filters.routerPersonId));
      const defaultOption = defaultSupplier
        ? { key: defaultSupplier.personId.toString(), value: defaultSupplier.supplierName }
        : null;
      setSelectedSupplier(defaultOption);
    }
  }, [filters.routerPersonId]);

  useEffect(() => {
    handleClearFilters();
  }, [selectedSupplier]);

  useEffect(() => {
    if (errorSuppliers) {
      if (DEBUG === 'TRUE') {
        console.log(`Erro ao carregar dados! Error:(message: ${errorSuppliers} )`);
      } else {
        toggleSnackbar({
          message: 'Ocorreu um problema ao carregar os fornecedores. Por favor, informe ao suporte.',
          type: 'error'
        });
      }
    }
  }, [errorSuppliers]);

  useEffect(() => {
    if (errorGroups) {
      if (DEBUG === 'TRUE') {
        console.log(`Erro ao carregar dados! Error:(message: ${errorGroups} )`);
      } else {
        toggleSnackbar({
          message: 'Ocorreu um problema ao carregar os fornecedores. Por favor, informe ao suporte.',
          type: 'error'
        });
      }
    }
  }, [errorGroups]);

  useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      personId: Number(selectedSupplier?.key),
      productDivisionIndicator: (selectedDivision?.key as InAcessMoveis) || undefined,
      productGroupId: selectedGroup ? Number(selectedGroup.key) : null,
      productId: searchTerm ? Number(searchTerm) : null,
      receiptDate: selectedDate ?? null
    }));
  }, [selectedSupplier, selectedDivision, selectedGroup, searchTerm, selectedDate]);

  return (
    <Can permissions={['filtro-fornecedor']}>
      <Snackbar />
      <div className={classes.root}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6} md={6} lg={2}>
            <Autocomplete
              showKeyProperty
              loading={loadingSuppliers}
              data={dataSuppliers}
              keyProperty="personId"
              valueProperty="supplierName"
              onChange={handleSupplierChange}
              value={selectedSupplier}
              label="Selecione o fornecedor"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={2}>
            <Autocomplete
              data={dataDivisions}
              keyProperty="productDivisionKey"
              valueProperty="productDivisionName"
              onChange={handleDivisionChange}
              value={selectedDivision}
              label="Selecione a divisão"
              defaultValue={''}
              disabled={!filters.personId}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={2}>
            <Autocomplete
              showKeyProperty
              data={dataGroups}
              keyProperty="productGroupId"
              valueProperty="productGroupName"
              onChange={handleGroupChange}
              value={selectedGroup}
              label="Selecione o grupo"
              defaultValue={''}
              loading={loadingGroups}
              disabled={!filters.productDivisionIndicator}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={2}>
            <SearchBar
              onSearch={handleSearch}
              label="Id Produto"
              disabled={!filters.personId}
              searchTerm={searchTerm}
              onClearSearch={() => setSearchTerm('')}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={2}>
            <DatePicker
              label="Dt. Recebimento"
              onChange={handleDateChange}
              selected={selectedDate}
              value={selectedDate}
              disabled={!selectedSupplier}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={2}>
            <div className={classes.buttonPosition}>
              <Button
                startIcon={<AddIcon />}
                variant="contained"
                color="primary"
                onClick={handleAddClick}
                className={classes.button}
              >
                ADICIONAR NOVO RELATÓRIO
              </Button>
            </div>
          </Grid>
        </Grid>
      </div>
    </Can>
  );
};
